<div class="skeleton-card">
    <div class="skeleton-qr"></div>
    <div class="skeleton-footer">
      <div class="skeleton-dot"></div>
      <div class="skeleton-dot"></div>
      <div class="skeleton-dot"></div>
    </div>
    <div class="skeleton-text"></div>
</div>